<modal-container #modal [headerTitle]="'bulk.edit'" [headerIconClass]="'far-edit'" [isExtraLargeModal]="true">
  <ng-container class="modal-button-show">
    <btn
      [label]="'bulk.edit'"
      [title]="'bulk.edit' | translate"
      [classes]="['btn-third', 'float-right', 'mr-2']"
      [icon]="'far-edit'"
      [btnType]="'button'"
      (click)="showChildModal()"
    >
    </btn>
  </ng-container>

  <ng-container class="modal-body-content">
    <div class="flex-column">
      <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>

      <div class="flex-gap-10 flex-row">
        <div class="flex-column w-50">
          <div class="card">
            <div class="row mt-2">
              <div class="flex-gap-5 flex-row">
                <div class="col">
                  <form-row-input
                    [label]="'purchasePrice.default'"
                    [class]="'input-unit'"
                    [icon]="'fa-money-bill'"
                    [(model)]="productChanges.purchasePrice"
                    [replaceComma]="true"
                    data-cy="product-price-default"
                  >
                    <p class="my-auto pt-2 font-size-input">
                      {{ productChanges.currency | formatCurrencyWithoutPrice }}
                    </p>
                  </form-row-input>
                </div>
                <div class="col">
                  <form-row-select
                    [(model)]="productChanges.supplier"
                    [label]="'supplier.default'"
                    [icon]="'fa-person-carry'"
                    [options]="suppliers"
                    [dataCyAttribute]="'product-supplier-select'"
                  ></form-row-select>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="flex-gap-5 flex-row">
                <div class="col">
                  <form-row-select
                    [label]="'product.vatrate'"
                    [(model)]="productChanges.vat"
                    [options]="vats"
                    class="margin-bottom"
                  >
                  </form-row-select>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="font-weight">
              {{ 'categories' | translate }}
            </div>

            <div>
              <form-row-select [title]="'categories'" [(model)]="categorySelectedOption" [options]="selectOptions">
              </form-row-select>
            </div>

            <category-tree
              *ngIf="isModalShown"
              [isInBulkEdits]="true"
              [categoryTreeLabel]="'product.tab.categories.categories'"
              [type]="categoryTreeTypeEnum.checkboxProductCategories"
              [categories]="categories"
              [(selectedCategories)]="productChanges.categories"
            >
            </category-tree>
          </div>
        </div>

        <div class="w-50">
          <div class="card">
            <div class="font-weight">
              {{ 'mainCategory' | translate }}
            </div>

            <div>
              <form-row-select
                [title]="'mainCategory'"
                [(model)]="mainCategorySelectedOption"
                [options]="mainCategorySelectOptions"
              >
              </form-row-select>
            </div>

            <category-tree
              *ngIf="mainCategorySelectedOption === 'set.selected' && isModalShown"
              [isInBulkEdits]="true"
              [categoryTreeLabel]="'product.tab.categories.mainCategory'"
              [type]="categoryTreeTypeEnum.radioProductMainCategory"
              [categories]="categories"
              (mainCategoryChange)="mainCategoryChanged($event)"
            ></category-tree>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container class="progress-overlay modal-body-content" *ngIf="isShowingProgress">
    <div class="progressbar-wrapper">
      <div class="card header-div">
        <button
          data-cy="close"
          type="button"
          class="close close-btn"
          aria-label="Close"
          (click)="close()"
          [title]="'close' | translate"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="progress-header">
          <div class="progressbar-div">
            <progress
              [ngClass]="isProgressFinish ? 'progress-finish' : 'progress-loading'"
              class="progress-bar-2"
              role="progressbar"
              [max]="numberOfAllProducts"
              [value]="numberOfUpdatedProducts"
            ></progress>
            <div *ngIf="updating">{{ numberOfUpdatedProducts + '/' + numberOfAllProducts }}</div>
            <div *ngIf="isProgressFinish" class="font-weight done">
              {{ 'done' | translate }}
              <i class="fa fa-check"></i>
            </div>
          </div>

          <btn
            *ngIf="!isProgressFinish"
            [label]="'suspend'"
            [title]="'suspend' | translate"
            [icon]="'far fa-ban'"
            [classes]="['btn-first']"
            (onEvent)="suspend()"
          >
          </btn>
        </div>

        <div class="error-list-div" *ngIf="updateErrors?.length > 0">
          <hr />
          <div class="font-weight text-center margin-bottom-10">
            {{ 'failed.to.edit' | translate }}
          </div>

          <div *ngFor="let err of updateErrors" class="error-message-div">
            <a class="link product-name" [target]="'_blank'" [routerLink]="['/product', err.productId]">
              {{ err.productName }}
            </a>
            <div class="error-message">{{ err.errMessage }}</div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container class="modal-footer-content">
    <btn
      [label]="'edit'"
      [title]="'edit' | translate"
      [icon]="'far-check'"
      [classes]="['btn-first']"
      (onEvent)="save()"
      data-cy="bulk-edits-submit"
    ></btn>
  </ng-container>
</modal-container>
